import "./style.css";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <App />
  // <>
  //   <Canvas
  //     // camera={{
  //     //   fov: 45,
  //     //   near: 0.1,
  //     //   far: 2000,
  //     //   position: [-3, 1.5, 4],
  //     // }}
  //     camera={{
  //       fov: cameraControls.fov,
  //       near: 0.1,
  //       far: 2000,
  //       position: [
  //         cameraControls.posX,
  //         cameraControls.posY,
  //         cameraControls.posZ,
  //       ],
  //     }}
  //   >
  //     <Suspense fallback={null}>
  //       <Experience />
  //     </Suspense>
  //   </Canvas>
  //   <Loader />
  // </>
);
